import { css } from '@emotion/css'
import { colors, fontSize, fontWeight, spacing } from '@offerzen/pinata'

const styles = {
  title: css({
    fontSize: fontSize.large,
    fontWeight: fontWeight.semiBold,
    color: colors.oxfordBlue,
    margin: 0,
    marginBottom: spacing.medium,
  }),

  form: css({
    display: 'grid',
    gridTemplateRows: 'repeat(3, auto)',
    gap: spacing.medium,
  }),

  nameInput: css({
    width: '100%',
  }),

  submit: css({
    justifySelf: 'end',
  }),

  errorMessage: css({
    margin: 0,
  }),
}

export default styles
